/**
 * Created by JIA on 2020/6/22.
 */
import React, { Component } from "react";
import PropTypes from "prop-types";
import { Animated, PixelRatio, Text, TextInput, View } from "react-native";
import _ from "lodash";

import { AppSizes } from "../../theme/";
import { convertToPinyin } from "../../utils/Helper";
import { GetDefaultAnswerToShow, IsAnswerRightForInput } from "../../utils/MarkTextHelper";
import SimpleSentence from "./SimpleSentence";

const fontSizeToCharWidth = 1; // this for CN char is good, but for eng char is not.
const defaultFontSize = 17;
const defaultHPadding = 5;
const defaultMinCharCount = 4;
const animateTiming = 350;

const isNumeric = n => {
    return !isNaN(parseFloat(n)) && isFinite(n);
};
const isASCII = string => /^[\x00-\x7F]*$/.test(string);

const getTranslatedCharWidth = value => {
    let count = 0.0;
    _.each(value, item => {
        if (isASCII(item)) {
            count += 0.7;
        } else {
            count += 1.23;
        }
    });
    return count;
};

const getMultilineTranslatedCharWidth = value => {
    var lines = value.split('\n');
    var maxLineCount = 0;
    for (let i = 0; i < lines.length; ++i) {
        var n = getTranslatedCharWidth(lines[i]);
        if (n > maxLineCount) {
            maxLineCount = n;
        }
    }
    return maxLineCount;
};

const calcInputWidth = (charCount, fontWidth, padding, initCount) => {
    let _fontWidth = fontWidth && isNumeric(fontWidth) ? _.toNumber(fontWidth) : defaultFontSize;
    _fontWidth = _fontWidth * fontSizeToCharWidth;
    _fontWidth = _fontWidth * PixelRatio.getFontScale();
    const _padding = padding && isNumeric(padding) ? _.toNumber(padding) : defaultHPadding;
    const maxWidth = AppSizes.screen.width;
    const realWidth = Math.max(charCount, initCount) * _fontWidth + _padding * 2;

    return PixelRatio.roundToNearestPixel(realWidth < maxWidth ? realWidth : maxWidth);
};

class AutoExpandTextInput extends Component {
    constructor(props) {
        super(props);

        const fillRestLine = props.initialCharCount === "f";

        const initCharCount = isNumeric(props.initialCharCount) && _.toNumber(props.initialCharCount) > 0 ? _.toNumber(props.initialCharCount) : defaultMinCharCount;

        let finalCount = initCharCount;
        let initVal = "";
        if (!_.isEmpty(props.defaultValue) && props.defaultValue.length > 0) {
            finalCount = Math.max(initCharCount, getTranslatedCharWidth(props.defaultValue));
            initVal = props.defaultValue;
        } else {
            if (!_.isEmpty(props.value) && props.value.length > 0) {
                if (props.inputProps && props.inputProps.multiline) {
                    finalCount = Math.max(initCharCount, getMultilineTranslatedCharWidth(props.value));
                }
                else {
                    finalCount = Math.max(initCharCount, getTranslatedCharWidth(props.value));
                }
                initVal = props.value;
            }
        }
        const realInputWidth = fillRestLine ? 0 : calcInputWidth(finalCount, props.fontSize, props.hPadding, initCharCount);
        this.state = {
            charCount: finalCount,
            defaultCharCount: initCharCount,
            bounceValue: new Animated.Value(realInputWidth),
            realWidth: realInputWidth,
            value: initVal,
            fillRestLine: fillRestLine,
            trueVal: props.trueVal,
        };
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        const fillRestLine = nextProps.initialCharCount === "f";
        if (!this.state.fillRestLine && fillRestLine) {
            this.setState({ fillRestLine: fillRestLine });
        } else {
            const initCharCount = isNumeric(nextProps.initialCharCount) && _.toNumber(nextProps.initialCharCount) > 0 ? _.toNumber(nextProps.initialCharCount) : defaultMinCharCount;
            const realInputWidth = calcInputWidth(this.state.charCount, nextProps.fontSize, nextProps.hPadding, initCharCount);
            let changed = false;
            let changedState = {};
            if (this.state.defaultCharCount !== initCharCount) {
                changedState = {
                    defaultCharCount: initCharCount,
                };
                changed = true;
            }
            if (this.state.realWidth !== realInputWidth) {
                Animated.timing(this.state.bounceValue, {
                    toValue: realInputWidth,
                    timing: animateTiming,
                }).start();

                changedState.realWidth = realInputWidth;
                changed = true;
            }

            if (changed) {
                this.setState(changedState);
            }
        }

        // when you set value from props, we just use your value as the value
        if (nextProps.value !== this.props.value && nextProps.value) {
            const val = nextProps.inputPinyinMode ? convertToPinyin(nextProps.value) : nextProps.value;

            const count = (nextProps.inputProps && nextProps.inputProps.multiline) ? getMultilineTranslatedCharWidth(val) : getTranslatedCharWidth(val);

            if (!fillRestLine) {
                const realInputWidth = calcInputWidth(count, nextProps.fontSize, nextProps.hPadding, this.state.defaultCharCount);

                Animated.timing(this.state.bounceValue, {
                    toValue: realInputWidth,
                    timing: animateTiming,
                }).start();
                this.setState({ charCount: count, realWidth: realInputWidth, value: val });
            } else {
                this.setState({ charCount: count, realWidth: 0, value: val });
            }
        }
    }

    render() {
        const { fontSize, inputProps, inputStyle, showRightOrWrongColor, showTips, showTipsBelow, tipTextStyle, placeholder, placeholderTextColor, style } = this.props;
        const { fillRestLine } = this.state;

        return (
            <View style={{ alignItems: "center", justifyContent: "center", }}>
                <Animated.View
                    style={[
                        styles.container,
                        fillRestLine
                            ? {
                                flex: 1,
                            }
                            : {
                                width: this.state.bounceValue,
                            },
                        style,
                    ]}>
                    <TextInput
                        style={[
                            styles.inputStyle,
                            { ...inputStyle },
                            {
                                fontSize: fontSize && _.isNumber(fontSize) ? fontSize : undefined,
                                //  lineHeight: fontSize && _.isNumber(fontSize) ? fontSize * fontSizeToCharWidth : undefined
                            },
                            { color: (showRightOrWrongColor && this.state.trueVal) ? (showTips ? "green" : IsAnswerRightForInput(this.state.value, this.state.trueVal) ? "green" : "red") : inputStyle.color },
                        ]}
                        autoCapitalize="none"
                        autoCorrect={false}
                        editable={true}
                        placeholderTextColor={placeholderTextColor}
                        underlineColorAndroid="rgba(0,0,0,0)"
                        allowFontScaling={true}
                        rejectResponderTermination={true}
                        {...inputProps}
                        placeholder={placeholder}
                        onBlur={this.onBlur}
                        onChangeText={this.onChangeText}
                        onEndEditing={e => this.onEndEditing(e, false)}
                        onSubmitEditing={e => this.onEndEditing(e, true)}
                        value={showTips ? GetDefaultAnswerToShow(this.state.trueVal) : this.state.value}
                    />
                </Animated.View>
                {(showTipsBelow && (this.state.trueVal && !IsAnswerRightForInput(this.state.value, this.state.trueVal))) ?
                 (<View>
                  <SimpleSentence style={tipTextStyle}>{GetDefaultAnswerToShow(this.state.trueVal)}</SimpleSentence>
                  </View>) : null
                }
                {(showTipsBelow && (!this.state.trueVal || IsAnswerRightForInput(this.state.value, this.state.trueVal))) ?
                 /* 底部提示占位, 让布局保持一致 */
                 (<Text allowFontScaling={true} style={tipTextStyle}>{" "}</Text>) : null
                }
            </View>
        );
    }

    onChangeText = val => {
        const count = (this.props.inputProps && this.props.inputProps.multiline) ? getMultilineTranslatedCharWidth(val) : getTranslatedCharWidth(val);

        if (!this.state.fillRestLine) {
            const realInputWidth = calcInputWidth(count, this.props.fontSize, this.props.hPadding, this.state.defaultCharCount);
            this.setState({ charCount: count, realWidth: realInputWidth, value: val });
            Animated.timing(this.state.bounceValue, {
                toValue: realInputWidth,
                timing: animateTiming,
            }).start();
        } else {
            this.setState({ charCount: count, realWidth: 0, value: val });
        }

        if (this.props.inputProps && this.props.inputProps.onChangeText && _.isFunction(this.props.inputProps.onChangeText)) {
            this.props.inputProps.onChangeText(val);
        }
        if (this.props.onChangeText && _.isFunction(this.props.onChangeText)) {
            this.props.onChangeText(val);
        }
    };

    onBlur = () => {
        if (this.props.onBlur && _.isFunction(this.props.onBlur)) {
            this.props.onBlur();
        }
    };

    /**
     * handle the pinyin mode , we will convert the input like wu3 to wu
     * @param e
     */
    onEndEditing = (e, forSubmit) => {
        if (e && e.nativeEvent) {
            const { text } = e.nativeEvent;
            let convertText = text;
            if (this.props.inputPinyinMode) {
                convertText = convertToPinyin(text);
            }
            const previousValue = this.state.value;
            this.setState({ value: convertText }, () => {
                if (this.props.inputProps && this.props.inputProps.onChangeText && _.isFunction(this.props.inputProps.onChangeText)) {
                    this.props.inputProps.onChangeText(convertText);
                }

                if (previousValue !== convertText) {
                    if (this.props.onChangeText && _.isFunction(this.props.onChangeText)) {
                        this.props.onChangeText(convertText);
                    }
                }

                if (forSubmit) {
                    if (this.props.inputProps && this.props.inputProps.onSubmitEditing && _.isFunction(this.props.inputProps.onSubmitEditing)) {
                        this.props.inputProps.onSubmitEditing(convertText);
                    }
                } else {
                    if (this.props.inputProps && this.props.inputProps.onEndEditing && _.isFunction(this.props.inputProps.onEndEditing)) {
                        this.props.inputProps.onEndEditing(convertText);
                    }
                }
            });
        }
    };

    getText = () => {
        return this.state.value;
    };
}

//for native base stuff we just pass plain objects
const styles = {
    inputStyle: {
        //alignSelf: "flex-end",
        //flex: 1,
        width: "100%",
        fontSize: defaultFontSize,
        // lineHeight: defaultFontSize * fontSizeToCharWidth,
        //height: 25,
        color: "#000",
        paddingLeft: 5,
        paddingRight: 5,
        justifyContent: "flex-start",
        paddingTop: 0,
        paddingBottom: 0,
        paddingVertical: 0,
        borderBottomWidth: 0,
        borderLeftWidth: 0,
        borderRightWidth: 0,
        borderTopWidth: 0,
    },
    container: {
        //alignItems: "center",
        //justifyContent: "center",
        backgroundColor: "transparent",
        borderBottomWidth: 0.6666666666666666,
        borderColor: "#D9D5DC",
        borderLeftWidth: 0,
        borderRightWidth: 0,
        borderTopWidth: 0,
        flexDirection: null,
        marginLeft: 2,
        //height: 26,
        // flexDirection: "row",
        justifyContent: "flex-start",
        // alignItems: "flex-start",
        alignSelf: "flex-start",
        // flexGrow: 1,
    },
};

AutoExpandTextInput.propTypes = {
    initialCharCount: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    fontSize: PropTypes.number,
    hPadding: PropTypes.number,
    inputStyle: PropTypes.object,
    inputProps: PropTypes.object,
    onChangeText: PropTypes.func,
    style: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
    onBlur: PropTypes.func,
    inputPinyinMode: PropTypes.bool,
    defaultValue: PropTypes.string,
    placeholder: PropTypes.string,
    trueVal: PropTypes.string,
    showRightOrWrongColor: PropTypes.bool,
    placeholderTextColor: PropTypes.string,
    value: PropTypes.string,
};

AutoExpandTextInput.defaultProps = {
    initialCharCount: defaultMinCharCount,
    fontSize: defaultFontSize,
    hPadding: defaultHPadding,
    inputStyle: {},
    style: {},
    inputProps: {},
    onChangeText: () => {},
    onBlur: () => {},
    inputPinyinMode: false,
    defaultValue: "",
    placeholder: "",
    trueVal: "",
    showRightOrWrongColor: false,
    placeholderTextColor: "#a5a5a5",
};

export default AutoExpandTextInput;
